import { useContext, useEffect } from "react";

import Context from "../../../context";
import LoginPage from "./LoginPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import SignUpPage from "./SignUpPage";

import LoginWrapper from "./LoginWrapper";
import { useHistory } from "react-router-dom";

import Modal from '../Modals/Modal'

export default function Login() {
  const { contextState, setContextState } = useContext(Context);
  const history = useHistory();
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get("token")) {
      history.push("/reset-password");
      localStorage.setItem("resetToken", searchParams.get("token"));
    }
  }, []);

  return (
    <LoginWrapper>
      {contextState.loginActivePage === "login" && <LoginPage />}
      {contextState.loginActivePage === "reset" && <ForgotPasswordPage />}
      {contextState.loginActivePage === "register" && <SignUpPage />}
      <Modal/>
    </LoginWrapper>
  );
}
